import { OriginRegexAllowList, QueryParamKeys } from './constants';
/**
 * Converts the urlQuery into an object with key value
 * mappings for the { QueryParamKeys }.
 */
export const extractURLQueryParams = urlQuery => {
  if (!urlQuery || urlQuery.indexOf('?') === -1) return {};
  const query = urlQuery.split('?')[1];
  const paramMap = decodeURIComponent(query).split('&').reduce((acc, param) => {
    const allParams = param.split('=');
    const [key, val] = allParams;
    if (key === QueryParamKeys.ID || key === QueryParamKeys.ORIGIN) {
      acc[key] = val;
    } else if (key === QueryParamKeys.INPAGE || key === QueryParamKeys.INCLUDE_HEAD_ELEMENTS || key === QueryParamKeys.SHOULD_REPLACE_ALL_HTML) {
      acc[key] = val.toLowerCase() === 'true' && true;
    }
    return acc;
  }, {});
  if (!paramMap[QueryParamKeys.ID]) {
    throw new Error('[content-embed-ui] must receive an `id` in the query parameters.');
  }
  return paramMap;
};

/**
 * Returns the origin of the document.referrer if it
 * matches one of the allowed host origins. If we cannot access
 * document.referrer, use the fallback origin query param.
 */
export const getHostOrigin = fallbackOrigin => {
  if (!document.referrer && !fallbackOrigin) {
    throw new Error('[content-embed-ui] must be loaded in an iframe with `referrerPolicy` set to `origin` or receive an `origin` param in the url query.');
  }
  const origin = document.referrer || fallbackOrigin;
  let hostOrigin;
  let originRegex;
  for (originRegex of OriginRegexAllowList) {
    const match = origin.match(originRegex);
    if (match) {
      hostOrigin = match[0];
      break;
    }
  }
  if (!hostOrigin) {
    throw new Error('[content-embed-ui] must be loaded from a valid HubSpot origin.');
  }
  return hostOrigin;
};